<template>
  <div style="width:100%;height:250px;">
    <div ref="chart" style="width:100%;height:100%;"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  props: {
    speedList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      myChart: null
    };
  },
  watch: {
    speedList: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.renderChart();
        });
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
      this.renderChart();
    });
    window.addEventListener('resize', this.resizeChart);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart);
    if (this.myChart) {
      this.myChart.dispose();
    }
  },
  methods: {
    initChart() {
      const dom = this.$refs.chart;
      if (!dom) return;
      if (this.myChart) {
        this.myChart.dispose();
      }
      this.myChart = echarts.init(dom);
    },
    renderChart() {
      if (!this.myChart || !this.speedList.length) return;

      const data = this.speedList;
      const xData = [];
      const speedData = [];
      const maxSpeed = Math.max(...data.map(item => item.speed || 0), 0);

      data.forEach(item => {
        xData.push(item.time.split(' ')[1] || item.time);
        speedData.push(item.speed);
      });

      // 状态颜色
      const stateColors = {
        0: '#F59E0B', // 空闲
        1: '#786B3E', // 试印
        2: '#07A4FF'  // 印刷
      };

      const option = {
        tooltip: {
          trigger: 'axis',
          confine: true
        },
        grid: {
          left: '2%',
          right: '2%',
          bottom: '5%',
          top: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: xData,
          // axisLabel: { show: false }, // 隐藏X轴文字，360条必开
          axisTick: { show: true },
          axisLine: { show: true }
        },
        yAxis: [
          { type: 'value', show: false }, // 隐藏左侧Y轴
          { type: 'value', position: 'left' }
        ],
        series: [
          {
            name: '状态',
            type: 'bar',
            yAxisIndex: 0,
            // ✅ 核心：无空隙设置
            barWidth: '100%',
            barCategoryGap: '0%',
            barGap: '0%',
            itemStyle: {
              color: (params) => {
                const state = data[params.dataIndex].state;
                return stateColors[state] || '#999';
              }
            },
            data: data.map(() => maxSpeed)
          },
          {
            name: '速度',
            type: 'line',
            yAxisIndex: 1,
            data: speedData,
            symbol: 'none',
            lineStyle: { width: 2, color: '#00AB84' }
          }
        ]
      };

      this.myChart.setOption(option, true);
    },
    resizeChart() {
      this.myChart?.resize();
    }
  }
};
</script>
